module.exports = __webpack_public_path__ + "img/banner.5d57481b.png";